import { createContext } from 'react';

import { Article } from '../../constants';

export const IssueContext = createContext<IssueContextProps>({
	language: 'en',
	issue: null,
	currentArticle: null,
	setCurrentArticle: () => {},
	articles: [],
	sw: null,
	setMode: () => {},
	articlesMap: undefined,
	fontSize: 62.5,
	setFontSize: () => {},
	setFavorites: () => {},
	favorites: null,
	languages: new Set<string>(),
	articleLanguages: new Set<string>(),
	disabledLanguages: new Set<string>(),
	setLanguage: () => {},
	audioPlayerUrl: null,
	setAudioPlayerUrl: () => {},
	showAudioPlayer: false,
	setShowAudioPlayer: () => {},
});

interface IssueContextProps {
	language: string;
	issue: any | null;
	currentArticle: any;
	articles: Array<Article>;
	sw: ServiceWorker | null;
	setCurrentArticle: Function;
	setMode: Function;
	articlesMap: Map<string, any> | undefined;
	fontSize: number;
	setFontSize: (size: number) => void;
	setFavorites: (value: Set<number>) => void;
	favorites: Set<number> | null;
	navigateToArticle?: (articleId: number) => void;
	languages: Set<string>;
	articleLanguages: Set<string>;
	disabledLanguages: Set<string>;
	setLanguage: (lang: string) => void;
	onClickLogOut?: () => void;
	audioPlayerUrl: string | null;
	setAudioPlayerUrl: (url: string | null) => void;
	showAudioPlayer: boolean;
	setShowAudioPlayer: (view: boolean) => void;
}
